import CommentModule from './comment.module'

export default CommentModule
